import { StyleSheet, css } from 'aphrodite'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import HeroSection from '../components/HeroSection'
import LandingSection from '../components/LandingSection'
import LandingFooter from '../components/navigation/LandingFooter'
import LandingHeader from '../components/navigation/LandingHeader'

export default function CareersPage() {
  const navigate = useNavigate()

  const handleJoinCommunityClick = () => {
    window.scrollTo(0, 0)
    navigate('/register')
  }

  return (
    <div className={css(styles.container)}>
      <LandingHeader />
      <HeroSection
        subtitle="Careers"
        title="CONSIDER A CAREER WITH DAYDACO!"
        description="Discover opportunities to be part of a community-driven platform that's transforming the Dump Truck Industry. At DayDaCo, we're building more than just software – we're creating a collaborative future."
        imageSrc="/careers1.jpg"
        imageAlt="Career opportunities at DayDaCo"
      />

      {/* Current Opportunities Section */}
      <section className={css(styles.opportunitiesSection)}>
        <div className={css(styles.opportunitiesContent)}>
          <h2 className={css(styles.sectionTitle)}>CURRENT OPPORTUNITIES</h2>
          <div className={css(styles.placeholderContent)}>
            <p className={css(styles.placeholderText)}>
              We are still in the process of listing opportunities, so please
              come back and visit us to see what positions are available.
            </p>
          </div>
        </div>
      </section>

      {/* Contact for Opportunities Section */}
      <section className={css(styles.contactSection)}>
        <div className={css(styles.contactContent)}>
          <h2 className={css(styles.contactTitle)}>
            CONTACT US FOR AVAILABLE OPPORTUNITIES
          </h2>
          <p className={css(styles.contactDescription)}>
            Interested in joining our team? We'd love to hear from you! Reach
            out to learn about current openings and future opportunities.
          </p>
          <button
            className={css(styles.contactButton)}
            onClick={() => navigate('/contact')}
          >
            Get in Touch
          </button>
        </div>
      </section>

      <LandingSection
        title="JOIN THE ECOSYSTEM"
        description="Work smarter with real-time updates, instant data access, and modular, digital templates and workflows. Cut down on paperwork, build trust, and reduce unnecessary driving – all in one Ecosystem."
        imageSrc="/ecosystem2.webp"
        imageAlt="Construction Team"
        buttonText="Join the Ecosystem"
        testimonialText="Trusted by 10,000+ operators,"
        userCount="contractors and haulers"
        onButtonClick={handleJoinCommunityClick}
      />

      <LandingFooter />
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
  },
  careerInfoSection: {
    padding: '40px 1rem',
    backgroundColor: '#F2F5F7',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      padding: '60px 2rem',
    },
    '@media (min-width: 1024px)': {
      padding: '80px 3rem',
    },
    '@media (min-width: 1280px)': {
      padding: '100px 5rem',
    },
  },
  careerInfoContent: {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  careerInfoTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '32px',
    fontWeight: 400,
    color: '#1F3D61',
    lineHeight: 1.2,
    '@media (min-width: 768px)': {
      fontSize: '48px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '60px',
    },
  },
  careerDescription: {
    fontSize: '16px',
    lineHeight: 1.5,
    color: '#4B5563',
    fontWeight: 400,
    '@media (min-width: 768px)': {
      fontSize: '18px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '20px',
    },
  },
  opportunitiesSection: {
    padding: '40px 1rem',
    backgroundColor: '#ffffff',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      padding: '60px 2rem',
    },
    '@media (min-width: 1024px)': {
      padding: '80px 3rem',
    },
    '@media (min-width: 1280px)': {
      padding: '100px 5rem',
    },
  },
  opportunitiesContent: {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  sectionTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '28px',
    fontWeight: 400,
    color: '#1F3D61',
    lineHeight: 1.2,
    '@media (min-width: 768px)': {
      fontSize: '36px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '48px',
    },
  },
  placeholderContent: {
    backgroundColor: '#F8F9FA',
    padding: '24px',
    borderRadius: '12px',
    border: '2px dashed #D1D5DB',
  },
  placeholderText: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#6B7280',
    fontStyle: 'italic',
    margin: 0,
    '@media (min-width: 768px)': {
      fontSize: '16px',
    },
  },
  contactSection: {
    padding: '40px 1rem',
    backgroundColor: '#F2F5F7',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      padding: '60px 2rem',
    },
    '@media (min-width: 1024px)': {
      padding: '80px 3rem',
    },
    '@media (min-width: 1280px)': {
      padding: '100px 5rem',
    },
  },
  contactContent: {
    maxWidth: '600px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'center',
  },
  contactTitle: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '28px',
    fontWeight: 400,
    color: '#1F3D61',
    lineHeight: 1.2,
    '@media (min-width: 768px)': {
      fontSize: '36px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '48px',
    },
  },
  contactDescription: {
    fontSize: '16px',
    color: '#4B5563',
    lineHeight: 1.5,
    '@media (min-width: 768px)': {
      fontSize: '18px',
    },
  },
  contactButton: {
    backgroundColor: '#6DC3FF',
    color: '#1F407E',
    padding: '12px 32px',
    borderRadius: '24px',
    fontSize: '16px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    ':hover': {
      backgroundColor: '#5AB4F0',
    },
  },
})
